import { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import APP from 'stores/APP';
import API from 'utils/API';
import AppLink from './APPLink';
import androidAppIcon from './images/android-app.png';
import iosAppIcon from './images/ios-app.png';
import { tryDownload } from './util';
import './style.scss';

export const appLinks: Array<{
    type: 'ios' | 'android';
    imgSrc: string;
    url: string;
}> = [
    { type: 'ios', imgSrc: iosAppIcon, url: 'https://apps.apple.com/app/tradeup-international/id1492602577' },
    {
        type: 'android',
        imgSrc: androidAppIcon,
        url: 'https://play.google.com/store/apps/details?id=com.tigerbrokers.tigertradeintl&hl=en'
    }
];

const Dlapp: React.FC = () => {
    function tryDownloadApp() {
        if (APP.isIOS) {
            tryDownload('ios');
        }

        if (APP.isAndroid) {
            tryDownload('android');
        }
    }

    useLayoutEffect(() => {
        tryDownloadApp();
    }, []);

    return (
        <section className="dlapp-root">
            <Helmet>
                <title>Cutting Edge Stock Trading Platforms by TradeUP</title>
                <meta
                    name="description"
                    content="TradeUP's online trading platform provides a wide array of tools and resources for you to trade with ease. You can keep tabs on the market, place orders, and monitor your positions all in one place!"
                />
            </Helmet>
            <h1>
                <a className="logo" href={API.PORTAL.host()}>
                    TradeUp
                </a>
            </h1>
            <header className="platform-header">
                <div className="header-content">
                    <div>Invest Anywhere Anytime </div>
                    <div className="header-content-long">
                        <span>We’re Adding More Value to </span>
                        <span>$0 Commission </span>
                    </div>
                </div>
                <div className="applink-container">
                    {appLinks.map(item => {
                        const { type, imgSrc, url } = item;

                        return <AppLink key={type} type={type} imgSrc={imgSrc} url={url} className="applink-item" />;
                    })}
                </div>
            </header>
        </section>
    );
};

export default Dlapp;
